import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import {
  confirmarSolicitudMedicacion,
  enviarPDFSolicitudMedicacion,
  repetirMedicacion
} from "../../../../actions/empadronamiento/Empadronamiento";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS, EMPADRONAMIENTO_TIPOS_NOTAS } from "../../../../utils/constants";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { MEDICACION_MENU_PERMISOS } from "../../../../utils/permisos";
import { ModalMotivoBajaMedicacion } from "./ModalMotivoBajaMedicacion";
import { ModalMotivoRechazoMedicacion } from "./ModalMotivoRechazoMedicacion";
import { ModalNotasMedicacion } from "./ModalNotasMedicacion";

export const AdministrarMenuMedicacion = (props) => {
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {} } = useSelector(
    (state) => state.empadronamiento
  );
  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [openModalMotivoBaja, setOpenModalMotivoBaja] = useState(false);
  const [openModalMotivoRechazo, setOpenModalMotivoRechazo] = useState(false);
  const [motivoBaja, setMotivoBaja] = useState("");
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [openModalNotas, setOpenModalNotas] = useState(false);
  const [idTipoNota, setIdTipoNota] = useState(null);

  const esAuditorCeiba = validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );

  const esAuditorOspe = validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  );

  console.log("esAuditorOspe", esAuditorOspe);

  const onClickEnviarMail = () => {
    dispatch(enviarPDFSolicitudMedicacion(solicitudSeleccionada.idSolicitud));
  };

  const onClickRetomar = () => {
    //setOpenModalGestionar(true);
    //dispatch(setReceta(item));
    props.postRetomarMedicacion(solicitudSeleccionada);
  };

  const onClickAutorizar = () => {
    dispatch(confirmarSolicitudMedicacion(solicitudSeleccionada.idSolicitud,
      EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA,
      false,
      props.setOpenModalGestionar
    ));
  };

  const onClickRepetir = () => {
    dispatch(repetirMedicacion(solicitudSeleccionada, props.postRetomarMedicacion));
  };

  const onClickAnular = () => {
    //setOpenModalMotivoRechazo(true);
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.ANULACION);
  };

  const onClickRechazar = () => {
    //setOpenModalMotivoRechazo(true);
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.RECHAZO);
  };

  const onClickDevolver = () => {
    ///dispatch(devolverMedicacion(solicitudSeleccionada.idSolicitud, props.setOpenModalGestionar, props.filtros));
    setOpenModalNotas(true);
    setIdTipoNota(EMPADRONAMIENTO_TIPOS_NOTAS.DEVOLUCION);
  };

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-evenly",
          flexWrap: "wrap",
        }}
      >
        {openModalNotas &&
          <ModalNotasMedicacion
            open={openModalNotas}
            close={() => {
              setOpenModalNotas(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            disabled={solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA ?
              false : props.disabled}
            titulo={"Agregar Nota"}
            nota={null}
            tipoNotaDisabled={true}
            tipoNota={idTipoNota}
            setOpenModalGestionar={props.setOpenModalGestionar}
            idEstadoSolicitud={solicitudSeleccionada?.idEstadoSolicitud}
          />

        }
        {openModalMotivoBaja && (
          <ModalMotivoBajaMedicacion
            open={openModalMotivoBaja}
            close={() => {
              setOpenModalMotivoBaja(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Motivo de Anulación"}
            motivoBaja={motivoBaja}
            setMotivoBaja={setMotivoBaja}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {openModalMotivoRechazo && (
          <ModalMotivoRechazoMedicacion
            open={openModalMotivoRechazo}
            close={() => {
              setOpenModalMotivoRechazo(false);
            }}
            idSolicitud={solicitudSeleccionada.idSolicitud}
            titulo={"Motivo de Rechazo"}
            motivoRechazo={motivoRechazo}
            setMotivoRechazo={setMotivoRechazo}
            setOpenModalGestionar={props.setOpenModalGestionar}
          />
        )}
        {/*solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "orange",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickReimprimir()
            }
          >
            Imprimir
          </Button>)*/}
        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA
          && (solicitudSeleccionada?.fechaFin !== null
            && new Date(solicitudSeleccionada?.fechaFin) >= new Date())
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickEnviarMail()
            }
          >
            Enviar por mail
          </Button>)}
        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA
          && (solicitudSeleccionada?.fechaFin !== null
            && new Date(solicitudSeleccionada?.fechaFin) >= new Date())
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "purple",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRepetir()
            }
          >
            Repetir
          </Button>)}
        {solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.EN_CARGA
          && !esAuditorCeiba
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "purple",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRetomar()
            }
          >
            Retomar
          </Button>)}
        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION
          && esAuditorCeiba)
          || (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION
            && esAuditorOspe))
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "green",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickAutorizar()
            }
          >
            Autorizar
          </Button>)}
        {/*(solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION
          || solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION
          || solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.EN_CARGA)
          && solicitudSeleccionada?.idUsuarioTomada > 0
          && solicitudSeleccionada?.idUsuarioTomada !== idUsuario
          && (<Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "pink",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickLiberar()
            }
          >
            Liberar
          </Button>)*/}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION
          && (validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ))) || (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION
            && (validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ))) ||
          solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.EN_CARGA)
          &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "black",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickAnular()
            }
          >
            Anular
          </Button>}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION
          && (validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ))) || (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION
            && (validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ))))
          &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "red",
              color: "white",
            }}
            variant="contained"
            onClick={() =>
              onClickRechazar()
            }
          >
            Rechazar
          </Button>}

        {((solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION
          && (validarSoloUnPermiso(
            permisosUser,
            MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
          ))) || (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION
            && (validarSoloUnPermiso(
              permisosUser,
              MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
            ))))
          &&
          <Button
            style={{
              margin: "0.5rem",
              flexBasis: "30%",
              backgroundColor: "yellow",
              color: "black",
            }}
            variant="contained"
            onClick={() =>
              onClickDevolver()
            }
          >
            Devolver
          </Button>}

      </div>
    </React.Fragment>
  );
};
